import React, { useState, useEffect } from 'react';

/**
 * アラートポップアップコンポーネントのプロパティ
 */
export interface AlertPopupProps {
  /** 表示するメッセージ */
  message: string;
  /** ポップアップの表示状態 */
  visible: boolean;
  /** ポップアップが閉じられた時のコールバック */
  onClose?: () => void;
}

/**
 * アラートポップアップコンポーネント
 *
 * 押せないものを押したときなどに表示するポップアップ。
 * OKボタンを押すと閉じる。
 */
export function AlertPopup({ message, visible, onClose }: AlertPopupProps) {
  const [isVisible, setIsVisible] = useState(visible);

  // visibleプロパティが変更されたときに内部状態を更新
  useEffect(() => {
    setIsVisible(visible);
  }, [visible]);

  // OKボタンがクリックされたときの処理
  const handleOkClick = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  // 表示されていない場合は何も表示しない
  if (!isVisible) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.0)',
        zIndex: 50000 // より高いzIndexを設定して常に最前面に表示
      }}
    >
      <div
        style={{
          width: '280px',
          // height: '116px',
          backgroundColor: 'white',
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          boxShadow: '0 0 44px rgba(17, 23, 23, 0.4)' // #111717 40%でぼかし44のシャドウ
        }}
      >
        <div
          style={{
            flex: 1,
            padding: '28px 24px 12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            color: '#4C4948',
            fontSize: '14px',
            fontFamily:
              '"メイリオ", Meiryo, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            textAlign: 'left'
          }}
        >
          {message}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '0px 24px 16px'
          }}
        >
          <button
            style={{
              backgroundColor: 'transparent',
              color: '#22A9BC',
              padding: '5px 15px',
              fontSize: '14px',
              fontFamily:
                '"メイリオ", Meiryo, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
              cursor: 'pointer'
            }}
            onClick={handleOkClick}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
